module.exports = __webpack_public_path__ + "static/img/health4.ea32685.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/health4.png
// module id = C3hs
// module chunks = 0